import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../../lib/constants";

export const History = () => {
  return (
    <section id="historia" className="relative py-20 md:py-28 bg-bege" data-testid="history-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
        {/* Text */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <div className="text-xs tracking-[0.3em] uppercase text-gold font-semibold mb-3" data-testid="history-overline">
            Nossa História
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-bordo font-semibold leading-tight" data-testid="history-title">
            De um carrinho na praça <br />
            <span className="italic">à mesa de Sorriso.</span>
          </h2>

          <div className="gold-ornament mt-6 mb-7" />

          <div className="space-y-5 text-[15px] md:text-base text-dark/85 leading-relaxed">
            <p>
              O <strong>Restaurante e Lanchonete O Padrinho</strong> nasceu de um carrinho de cachorro-quente
              na <strong>Praça da Juventude</strong>, movido por trabalho, fé e muita vontade de servir bem.
              O que começou de forma simples, com poucos recursos mas muito coração, foi crescendo junto com
              a cidade de Sorriso — e hoje, <strong>28 anos depois</strong>, segue no mesmo lugar, com a mesma essência.
            </p>
            <p>
              Ao longo dessas quase três décadas, o O Padrinho não serviu apenas refeições. <em>Serviu memórias.</em>
              Viu crianças crescerem, famílias se formarem e clientes de longa data se tornarem amigos.
              Daqui, nossa família conquistou a casa própria, criou os filhos, investiu em educação e provou
              que o trabalho honesto transforma vidas.
            </p>
            <p className="border-l-4 border-gold pl-5 italic text-bordo font-medium">
              O segredo de tudo isso? Uma só palavra: <strong>gratidão.</strong>
              Gratidão a Deus, à família e ao povo de Sorriso, que nos abraçou desde o primeiro dia.
            </p>
          </div>
        </motion.div>

        {/* Images */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="grid grid-cols-2 gap-5"
        >
          <figure className="flex flex-col card-hover" data-testid="history-image-cart">
            <div className="rounded-2xl overflow-hidden shadow-xl border-2 border-gold/40 aspect-[3/4] bg-white">
              <img
                src={IMAGES.historyCart}
                alt="O carrinho original do Padrinho na Praça da Juventude"
                className="w-full h-full object-cover"
              />
            </div>
            <figcaption className="mt-3 text-center text-xs md:text-sm text-bordo italic font-medium px-2">
              Tudo começou aqui — o carrinho que virou tradição
            </figcaption>
          </figure>

          <figure className="flex flex-col card-hover mt-8" data-testid="history-image-family">
            <div className="rounded-2xl overflow-hidden shadow-xl border-2 border-gold/40 aspect-[3/4] bg-white">
              <img
                src={IMAGES.historyFamily}
                alt="Helena e Paola, do Restaurante O Padrinho"
                className="w-full h-full object-cover"
              />
            </div>
            <figcaption className="mt-3 text-center text-xs md:text-sm text-bordo italic font-medium px-2">
              Helena e Paola — o coração e as mãos que alimentam Sorriso
            </figcaption>
          </figure>
        </motion.div>
      </div>

      {/* Team photo — full width below */}
      <motion.figure
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mt-16 md:mt-20 max-w-7xl mx-auto px-6 md:px-10"
        data-testid="history-team-photo"
      >
        <div className="rounded-3xl overflow-hidden shadow-2xl border-2 border-gold/40 bg-white">
          <img
            src={IMAGES.team}
            alt="Equipe do Restaurante O Padrinho"
            className="w-full h-auto object-cover block"
          />
        </div>
        <figcaption className="mt-5 text-center text-base md:text-lg text-bordo italic font-medium max-w-3xl mx-auto leading-relaxed">
          Nossa equipe — as mãos e o coração que alimentam Sorriso há 28 anos.{" "}
          <span className="not-italic">🧡</span>
        </figcaption>
      </motion.figure>
    </section>
  );
};

export default History;
